import { errorActions } from "@/alerts";
import axios from "@/api";
import { money, format } from "@/publicjs/money";

const formatMoneyValue = (value) => {
  const numericValue = Number(value);
  return (
    money() + "" + format(Number.isFinite(numericValue) ? numericValue : 0)
  );
};
/**
 * Funcion para enviar correo al momento de cerrar la caja
 * @param {*} data Los datos principales del cuadre de caja
 * @param {*} userName El nombre del usuario
 * @param {*} subject Asunto del correo
 */
export const sendCloseBox = async (data, userName, subject) => {
  const baseURL = window.location.href;
  const pathURL = baseURL.split("/").slice(0, 3).join("/");
  const {
    idStore,
    idTurn,
    amountInTheBox,
    totalClosingAmount,
    transferAmount,
    cashAmount,
    targetAmount,
    chequeAmount,
    creditSalesAmount,
    totalPagosMensajero,
    totalPagosCuentasPorCobrar,
  } = data;
  try {
    await axios.post(
      "mensaje-de-cierre-de-caja",
      {
        idStore,
        idTurn,
        urlWebSite: pathURL,
        userName,
        subject,
        amountInTheBox: formatMoneyValue(amountInTheBox),
        totalClosingAmount: formatMoneyValue(totalClosingAmount),
        transferAmount: formatMoneyValue(transferAmount),
        cashAmount: formatMoneyValue(cashAmount),
        targetAmount: formatMoneyValue(targetAmount),
        chequeAmount: formatMoneyValue(chequeAmount),
        creditSalesAmount: formatMoneyValue(creditSalesAmount),
        totalPagosMensajero: formatMoneyValue(totalPagosMensajero),
        totalPagosCuentasPorCobrar: formatMoneyValue(
          totalPagosCuentasPorCobrar,
        ),
      },
      {
        method: {
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    errorActions(error);
  }
};
/**
 * Funcion para enviar correo al momento de abrir la caja
 * @param {*} data Los datos principales del cuadre de caja
 * @param {*} userName El nombre del usuario
 * @param {*} subject Asunto del correo
 */
export const sendOpenBox = async (data, userName, subject) => {
  const { idStore, startingAmount } = data;
  try {
    await axios.post(
      "mensaje-de-apertura-de-caja",
      {
        idStore,
        userName,
        subject,
        startingAmount: formatMoneyValue(startingAmount),
      },
      {
        method: {
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    errorActions(error);
  }
};
